import { createContext } from '../utils';
import defaultTheme from '../theme/default-theme';
import { pp2EnglandTheme, pp2NorthernIrelandTheme, pp2WalesTheme, tqTheme } from './theme';
export var getTheme = locale => {
  switch (locale) {
    default:
    case 'default':
      return defaultTheme;
    case 'tq':
      return tqTheme;
    case 'england':
      return pp2EnglandTheme;
    case 'wales':
      return pp2WalesTheme;
    case 'northern-ireland':
      return pp2NorthernIrelandTheme;
  }
};
export var [LocaleProvider, useLocale] = createContext({
  name: 'LocaleProvider',
  errorMessage: 'useLocale: `locale` is undefined. Seems you forgot to wrap the components in `<LocaleProvider />` '
});